// extracted by mini-css-extract-plugin
export var addButton = "_i9-0";
export var border = "_i9-8";
export var check = "_i9-h";
export var danger = "_i9-6";
export var dropdownContainer = "_i9-1";
export var editModalBody = "_i9-j";
export var footerContainer = "_i9-i";
export var fullWidth = "_i9-a";
export var hide = "_i9-9";
export var icon = "_i9-3";
export var input = "_i9-7";
export var inputFlex = "_i9-b";
export var inputWrapper = "_i9-c";
export var manualFocus = "_i9-5";
export var optionButton = "_i9-4";
export var pillWrapper = "_i9-e";
export var pointer = "_i9-2";
export var showOverflow = "_i9-f";
export var tagsFlex = "_i9-d";
export var xButton = "_i9-g";